export default function slugify(text: string) {
  return text
    .toLowerCase()
    .replace(/ł/g, "l")
    .replaceAll(" ", "-")
    .normalize("NFD")
    .replace(/\p{Diacritic}/gu, "");
}
